// extracted by mini-css-extract-plugin
export default {"formGroup":"ContactPage_formGroup__PvWJ2","submitButton":"ContactPage_submitButton__BvgdY"};